import React, { useState } from 'react';
import { Zap } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import ContactModal from './ContactModal';
import InfoModal from './InfoModal';
import { infoContent } from '../data/infoContent';

const cols = [
  { title: 'MARKETS', links: ['Unlisted Markets', 'Upcoming Pipeline', 'Order Book Depth', 'Valuation Data'] },
  { title: 'PLATFORM', links: ['Portfolio & Escrow', 'Vault Funding', 'Architecture & Spec', 'API Access'] },
  { title: 'COMPLIANCE', links: ['SEC Rule 506(c)', 'Accredited KYC', 'ROFR & SPV Rules', 'Risk Disclosures'] },
  { title: 'COMPANY', links: ['About ApexForge', 'Institutional Desk', 'Careers', 'Contact'] },
];

// Links that navigate to real pages
const routeMap = {
  'Unlisted Markets': '/',
  'Upcoming Pipeline': '/pipeline',
  'Portfolio & Escrow': '/portfolio',
};

export default function Footer() {
  const navigate = useNavigate();
  const [contactOpen, setContactOpen] = useState(false);
  const [info, setInfo] = useState(null);

  const handleClick = (e, label) => {
    e.preventDefault();
    if (routeMap[label]) {
      navigate(routeMap[label]);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else if (label === 'Contact') {
      setContactOpen(true);
    } else if (infoContent[label]) {
      setInfo(infoContent[label]);
    }
  };

  return (
    <footer className="border-t border-[var(--border)] mt-20">
      <div className="max-w-[1320px] mx-auto px-5 py-14">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2.5">
              <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-[var(--orange)] to-[#c2410c] flex items-center justify-center">
                <Zap size={16} className="text-white fill-white" />
              </div>
              <span className="font-display font-bold text-[15px] text-white">APEXFORGE <span className="text-[var(--muted)] font-normal">ATS</span></span>
            </Link>
            <div className="text-[9px] tracking-[0.18em] text-[var(--muted-2)] mt-2 font-mono">US UNLISTED EQUITIES</div>
            <p className="text-[13px] text-[var(--muted)] mt-5 leading-relaxed max-w-[240px]">
              Institutional alternative trading system for private US unicorn shares. Members-only secondary liquidity for accredited investors.
            </p>
            <p className="text-[10px] font-mono text-[var(--muted-2)] mt-6 tracking-wider">
              APEXFORGE MARKETS ATS • MEMBER FINRA / SIPC (SIMULATED)
            </p>
          </div>
          {cols.map((col) => (
            <div key={col.title}>
              <h4 className="text-[11px] font-mono tracking-[0.15em] text-[var(--muted-2)] mb-4">{col.title}</h4>
              <ul className="space-y-3">
                {col.links.map((l) => (
                  <li key={l}>
                    <a
                      href="#"
                      onClick={(e) => handleClick(e, l)}
                      className="text-[13px] text-[var(--muted)] hover:text-[var(--orange)] transition-colors"
                    >
                      {l}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-[var(--border)] mt-12 pt-6 flex flex-col md:flex-row items-center justify-between gap-3">
          <p className="text-[11px] font-mono text-[var(--muted-2)] tracking-wider">
            © 2025 APEXFORGE MARKETS. ALL DATA SIMULATED FOR DEMONSTRATION.
          </p>
          <p className="text-[11px] font-mono text-[var(--muted-2)] tracking-wider">
            NOT AN OFFER TO BUY OR SELL SECURITIES. <Link to="/admin" className="text-[var(--muted)] hover:text-[var(--orange)] transition-colors">Admin Console</Link>
          </p>
        </div>
      </div>
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} />
      <InfoModal content={info} open={!!info} onClose={() => setInfo(null)} />
    </footer>
  );
}
